import React, { useState, useEffect } from "react";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { Formik, Form } from "formik";
import { navigate } from "gatsby";
import loadable from "@loadable/component";

import {
  initialValues,
  validation,
  jakartaValidation,
  jakartaInitialValues,
} from "./constant.js";

import PrimaryButton from "components/Design/Button/PrimaryButton";

import {
  structureJakartaMailData,
  structureMailData,
} from "utils/structureMailData";
import * as REASON from "store/constants/support";
import { contactAyana } from "apis/contactAyana";
import { BALI, KOMODO, JAKARTA } from "store/constants/hotel";

const GeneralInquiry = loadable(() => import("./Reason/GeneralInquiry"));
const JakartaGeneralInquiry = loadable(() =>
  import("./Reason/JakartaGeneralInquiry")
);

const mapReasonOptions = ({ location }) => {
  const options = {
    [BALI]: [
      {
        value: REASON.GENERAL_INQUIRY,
        label: "General Inquiry",
      },
    ],
    [KOMODO]: [
      {
        value: REASON.GENERAL_INQUIRY,
        label: "General Inquiry",
      },
    ],
    [JAKARTA]: [],
  };

  return options[location];
};

const RenderInquiry = ({ reason, location, hotels }) => {
  if (location === JAKARTA) {
    return <JakartaGeneralInquiry />;
  }

  switch (reason) {
    case REASON.GENERAL_INQUIRY:
      return <GeneralInquiry hotels={hotels} />;

    default:
      break;
  }
};

const SupportForm = ({ hotels, navigateBackTo, location, recipients }) => {
  const { t } = useTranslation("support");
  const { language } = useI18next();
  const reasonOption = mapReasonOptions({ location });
  const [selectedKey, setSelectedKey] = useState(0);
  const [selectedDestination, setSelectedDestination] = useState();
  const [selectedSubDestination, setSelectedSubDestination] = useState();

  const handleSubmit = async (values, actions) => {
    actions.validateForm();
    try {
      let recipient;
      if (location === JAKARTA) {
        recipient = recipients.find((item) => item.location === location);
      } else {
        recipient = recipients.find((item) => item.reason === values.reason);
      }

      let recipientEmails =
        Boolean(recipient.emails.length) && recipient.emails;

      const reason = reasonOption?.find(
        (reason) => reason.value === recipient.reason
      );

      let mailValues;
      if (location === JAKARTA) {
        mailValues = structureJakartaMailData(values, recipient);
      } else {
        mailValues = structureMailData(
          values,
          language,
          recipientEmails,
          reason?.label,
          location
        );
      }

      await contactAyana(mailValues);
      navigate(navigateBackTo);
      actions.setSubmitting(false);
    } catch (error) {}
  };

  const jakartaValues =
    location === JAKARTA && jakartaInitialValues({ language });

  const formValidation =
    location === JAKARTA
      ? jakartaValidation
      : validation[reasonOption[selectedKey]?.value];
  return (
    <Formik
      initialValues={{
        reason: reasonOption[selectedKey]?.value,
        ...initialValues(
          selectedDestination,
          selectedSubDestination,
          language,
          location
        )[reasonOption[selectedKey]?.value],
        hotels: hotels,
        ...jakartaValues,
      }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={formValidation}
      onSubmit={(values, actions) => {
        handleSubmit(values, actions);
      }}>
      {(props) => (
        <Form className="flex flex-col items-end w-full pb-40 border-b border-gray-light md:border-none">
          <div className="w-full md:border md:border-gray-light rounded-sm md:shadow-booking-form mb-16">
            <RenderInquiry
              reason={reasonOption[selectedKey]?.value}
              location={location}
              hotels={hotels}
            />
          </div>
          <div className="w-full lg:w-200 px-20 lg:px-0">
            <PrimaryButton type="submit" label={t("Submit")} block />
          </div>
        </Form>
      )}
    </Formik>
  );
};

SupportForm.defaultProps = {
  reason: "",
  destination: "", //destination is used for all selected destination ( destination, resto, spa )
};

export default SupportForm;
